import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuGendersGetRequest = simpleAction(TYPES.SKU_GENDERS_GET_REQUEST);

/**
 * Request skuGenders success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuGendersGetSuccess = simpleAction(TYPES.SKU_GENDERS_GET_SUCCESS);

/**
 * Request skuGenders error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuGendersGetError = simpleAction(TYPES.SKU_GENDERS_GET_FAIL);
